module.exports = __webpack_public_path__ + "img/avatar2.31996a5d.png";